import { DItemRangoCasillas } from "@dian-cmp/formulario";
import { DDocumento } from "@dian/api-formulario";

export class CopyModelService {

    private rangeBody: DItemRangoCasillas;

    constructor(
        range: DItemRangoCasillas,
    ) {
        this.rangeBody = range;
    }

    copyModel(modelOrigin: DDocumento, modelTarget: DDocumento): DDocumento {
        for (let i = this.rangeBody.casillaMin; i <= this.rangeBody.casillaMax; i++) {
            modelTarget.doc.cuerpo['cs_id_' + i] = modelOrigin.doc.cuerpo['cs_id_' + i];
        }
        return modelTarget;
    }    
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/copy-model.service.ts